import { Role } from 'types/api';

export const isAdmin = (role: Role | undefined): boolean => {
  let isAdmin = false;
  if (role === Role.ORGANIZATION_ADMIN || role === Role.SUPER_ADMIN) {
    isAdmin = true;
  }
  return isAdmin;
};
